import { twc } from 'react-twc';

import { twx } from '@/utils/twx';

export const Title = twx.h1`text-gray-1 text-[18px] md:text-[22px] 2xl:text-[30px] font-bold`;
export const TitleDescription = twx.p`text-gray-2 text-[14px] 2xl:text-lg`;
export const TitleWrapper = twx.div`pt-2 pb-2.5 md:py-2.5 gap-3 2xl:gap-[30px] md:flex-row md:items-center flex flex-col gap-2 items-start md:mb-1 flex-1`;

export const ContentBox = twc.div`flex justify-center items-center flex-col min-h-[calc(100dvh-200px)] bg-white`;

export const ContentPaper = twc.div`min-h-[calc(100dvh-192px)] px-2  py-4 md:px-6 md:py-7 bg-white rounded-2xl`;
export const ContentPaperExpand = twx.div`min-h-[calc(100dvh-164px)] px-2 py-4 md:px-6 md:py-7 bg-white rounded-2xl flex flex-col items-center gap-3.5`;

export const ContentText = twc.p`text-gray-2 font-bold text-4xl text-center mt-10`;

export const MobileDescription = twc.p`text-[18px] leading-[1.5] text-cds-coolgray-85 md:text-[20px] h-fit`;
export const MobileBold = twc.b`font-semibold text-cds-black-99`;
export const MobileWrapper = twx.div`mt-3 px-3.5 md:px-0 flex 2xl:hidden justify-between min-h-9 items-center`;
export const MobileBreak = twc.br`md:hidden`;
